module.exports = __webpack_public_path__ + "static/media/icoAttachment-Dark.abaa69db.svg";